export const CHANGE_REPORTTYPE = 'CHANGE_REPORTTYPE';

export const changeReportTypeAction = (reportType) => {
    return {
        type: CHANGE_REPORTTYPE,
        payload: reportType
    }
}